import '.././App.css';
import '../Styles/DevPage.css';
import '../Styles/MainPage.css';

import getProjectData from '../DataManagement/DataManagerDev.js';

import DevProject from '../Components/DevProject';


function DevPage() {

    return(
        <>
            <div className="listContainer">

                <DevProject
                    projectData={getProjectData('HB')}
                    pageID='project_app_HB'/>

                <DevProject
                    projectData={getProjectData('TTT3D')}
                    pageID='project_app_TTT3D'
                    inverted/>
               
               <DevProject
                    projectData={getProjectData('PV')}
                    pageID='project_app_PV'/>    

            </div>
        </>
    );

}

export default DevPage;